// import modular Routes
import homeRoutes from './Home';
import authRoutes from './Auth';

export default [
    ...homeRoutes,
    ...authRoutes,
];



// WEBPACK FOOTER //
// ./src/Routes/Routes.js